import { type ReactNode } from 'react';
import { Button, type ButtonProps } from '../components/buttons/Button';

export function TableActions({ children }: { children: ReactNode }) {
	return <div className="flex flex-row items-center justify-center gap-2">{children}</div>;
}

function TableButton(props: ButtonProps) {
	return <Button appearance="ghost" {...props} />;
}

interface TableButtonDefaultIconProps extends Omit<ButtonProps, 'Icon'> {}

function TableViewButton(props: TableButtonDefaultIconProps) {
	return <Button appearance="ghost" actionType="view" {...props} />;
}

function TableAddButton(props: TableButtonDefaultIconProps) {
	return <Button appearance="ghost" actionType="add" {...props} />;
}

function TableDeleteButton(props: TableButtonDefaultIconProps) {
	return <Button appearance="ghost" actionType="delete" {...props} />;
}

function TableEditButton(props: TableButtonDefaultIconProps) {
	return <Button appearance="ghost" actionType="edit" {...props} />;
}

TableActions.Button = TableButton;
TableActions.ViewButton = TableViewButton;
TableActions.AddButton = TableAddButton;
TableActions.DeleteButton = TableDeleteButton;
TableActions.EditButton = TableEditButton;
